import type { QueryClient } from '@tanstack/react-query';
import type { UserNoteEntityType } from '@shared/schema';
import { userNoteEntityResource } from '@shared/userNoteEntityResource';
import { entityDetailKey, invalidateEntity } from '@/lib/queryKeys';

/** Keep every reader of a record in sync with the canonical append response. */
export function refreshUserNoteViews(
  queryClient: QueryClient,
  entityType: UserNoteEntityType,
  entityId: number,
  notesUser: string,
  updatedAt: string | Date,
): void {
  const resource = userNoteEntityResource(entityType);
  queryClient.setQueryData(entityDetailKey(resource, entityId), (current: any) => (
    current ? { ...current, notes_user: notesUser, updatedAt } : current
  ));
  invalidateEntity(queryClient, resource, entityId);
}
